import type { ReactNode } from 'react';

interface PageHeroProps {
  kicker: string;
  title: ReactNode;
  lead: string;
  image?: string;
  imageAlt?: string;
  children?: ReactNode;
}

export function PageHero({ kicker, title, lead, image, imageAlt = '', children }: PageHeroProps) {
  return (
    <section className="page-hero">
      {image && (
        <div className="page-hero-media" aria-hidden="true">
          <img src={image} alt={imageAlt} />
          <div className="page-hero-overlay" />
        </div>
      )}
      <div className="page-shell page-hero-content">
        <p className="eyebrow eyebrow-light reveal is-visible">
          <span aria-hidden="true" /> {kicker}
        </p>
        <h1 className="reveal is-visible">{title}</h1>
        <p className="page-hero-lead reveal is-visible">{lead}</p>
        {children && <div className="page-hero-extra reveal is-visible">{children}</div>}
      </div>
    </section>
  );
}
